// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.scss\"","shadowSmall":"0 2px 6px rgba(0, 0, 0, .1)","smallWidth":"768px","container":"BrandLibraryContent_container__37otd"};